import { FC, SVGProps } from "react";

const CloseCircle: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="243"
      height="243"
      viewBox="0 0 243 243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="121.5" cy="121.5" r="117" stroke="white" strokeWidth="9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.75 137.307L159.722 175.279L175.278 159.723L137.306 121.751L175.278 83.779L159.722 68.2227L121.75 106.194L83.778 68.2227L68.2217 83.779L106.194 121.751L68.2217 159.723L83.778 175.279L121.75 137.307Z"
        fill="white"
      />
    </svg>
  );
};

export default CloseCircle;
